const { logger } = require('@fiverr-private/obs');

const { DEFAULT_LOCALE } = require('../constants');


const getDefaultLocaleValue = (k) => {
    try {
        return i18n.t(k, { $scope: DEFAULT_LOCALE });
    }
    catch (err) {
        logger.error(`Failed to get default value for key ${k}`);
        return false;
    }
};

module.exports = {
    getDefaultLocaleValue
};